import { connect } from 'react-redux';
import Header from '../../components/Header';

import { toggleModal } from '../slices/modalSlice';

const mapState = (state) => ({
  isConnected: state.user.isConnected,
  informations: state.user.informations,
});

const mapDispatch = (dispatch) => ({
  toggleModal: () => {
    const action = toggleModal();
    dispatch(action);
  },
});

export default connect(mapState, mapDispatch)(Header);
